module.exports = __webpack_public_path__ + "img/chrome.58c3301b.svg";